// gloss
export const REWARD_TYPES = {
  PHYSICAL: 'physical',
  DIGITAL: 'digital',
} as const;

export type RewardType = (typeof REWARD_TYPES)[keyof typeof REWARD_TYPES];

export const isValidRewardType = (value: unknown): value is RewardType =>
  typeof value === 'string' && (Object.values(REWARD_TYPES) as string[]).includes(value);
